/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyJobExecutionGroupQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicyJobExecutionGroupQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicyJobExecutionGroupQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicyJobExecutionGroupQueryOperator>): PolicyJobExecutionGroupQueryOperator {
        let obj = Object.assign(new PolicyJobExecutionGroupQueryOperator(), model);
        PolicyJobExecutionGroupQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyJobExecutionGroupQueryOperator>): PolicyJobExecutionGroupQueryOperator {
        if (!model) return null;
        return PolicyJobExecutionGroupQueryOperator.newInstance(<PolicyJobExecutionGroupQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyJobExecutionGroupQueryOperator) {
        if (!obj) return;

        models.PolicyJobExecutionGroupQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyJobExecutionGroupQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyJobExecutionGroupQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Policy job execution groups to include
     */
    execution_groups: Array<models.PolicyJobExecutionGroup>;

}
